import React, { useEffect, useState } from 'react'
import useApi from '../../hooks/useApi';
import { customStringify, getAgencyInfluencerProfile } from '../../utils';
import { FormattedMessage, useIntl } from 'react-intl';
import { network_tl, required_tl } from '../../translations';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { set_active_profile, set_data } from '../../redux/slices/influencerProfileSlice';
import Loading from "../Loading";
import RetryApi from "../RetryApi";

const ProfileContainer = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const { Axios } = useApi();
  const intl = useIntl();
  const dispatch = useDispatch();
  const {count} = useSelector(state => state.influencer_profile)


  const getData = async () => {

    try {
      setError(false)
      setLoading(true)
      const result = await Axios.get(`api/user/listing-agency-influencer?limit=${10000}`);
      dispatch(set_data(result.data.payload))
      setLoading(false);
    } catch (e) {
      if (e.response) {
        setError(customStringify(e.response.data.description))
        setLoading(false)
      } else if (axios.isCancel(e)) {

      }
      else {
        setError(network_tl(intl))
        setLoading(false)
      }
    }
  }

  useEffect(() => {
    getData()
  }, [count])

  //set active profile here
  useEffect(() => {
    dispatch(set_active_profile(getAgencyInfluencerProfile()))
  }, [])

  return (
    <>
      {
        loading && !error ?
          <div className='h-full w-full flex flex-col justify-center items-center'>
            <p>
              <FormattedMessage id="please_wait" defaultMessage={"Please wait..."} />
            </p>
            <Loading />
          </div>
          : !loading && error ?
            <RetryApi error={error} retry={getData} />
            : !loading && !error ?
              children
              :
              null
      }
    </>
  )
}

export default ProfileContainer